import type { CoinbaseProfileMenuResource } from '@cbhq/identity-api-hooks/profile-menu/types';
import { CircularQueue } from '@cbhq/identity-shared/utils';

const fallbackIconQueue = new CircularQueue([
  'chartCandles',
  'api',
  'application',
  'bank',
  'blockchain',
  'bookmarkInactive',
]);

export function parseResources(
  resources: CoinbaseProfileMenuResource[] | undefined,
  hidePersonalResource?: boolean,
  hidePersonalLegalEntity?: boolean,
  userUuid?: string,
): CoinbaseProfileMenuResource[] {
  if (!resources) {
    return [];
  }

  const parsed = resources
    .filter(({ resourceType, identityAccountId }) => {
      if (resourceType === 'user') {
        return !hidePersonalResource;
      }

      if (resourceType === 'legal_entity') {
        // Exclude the user's own personal legal entity when requested
        if (hidePersonalLegalEntity && userUuid && identityAccountId === userUuid) {
          return false;
        }

        return true;
      }

      return false;
    })
    .map((resource) => {
      // If resource already has an icon or logoUrl, return as is
      if (resource.icon || resource.logoUrl) {
        return resource;
      }

      // Add fallback icon if none exists
      return { ...resource, icon: fallbackIconQueue.get() };
    });

  return parsed;
}
